"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "footer bg-gray-darker py-4 border-red border-t-2" };
const _hoisted_2 = { class: "w-full 2xl:container mx-auto px-4 block lg:flex text-white" };
const _hoisted_3 = {
    key: 0,
    class: "lg:grow mb-5 lg:mb-0 text-center"
};
const _hoisted_4 = { class: "font-bold text-center uppercase mb-3" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "text-center" };
const _hoisted_7 = ["href"];
const _hoisted_8 = { class: "text-center mb-2" };
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { key: 2 };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { class: "text-center" };
const _hoisted_13 = ["href"];
const _hoisted_14 = {
    key: 1,
    class: "font-bold underline"
};
const _hoisted_15 = { key: 2 };
const _hoisted_16 = { class: "text-center mb-2" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { key: 2 };
const _hoisted_20 = { class: "text-center" };
const _hoisted_21 = ["href"];
const _hoisted_22 = {
    key: 1,
    class: "font-bold underline"
};
const _hoisted_23 = { key: 2 };
const _hoisted_24 = { class: "text-center mb-2" };
const _hoisted_25 = { key: 0 };
const _hoisted_26 = { key: 1 };
const _hoisted_27 = { key: 2 };
const _hoisted_28 = { class: "lg:grow mb-5 lg:mb-0" };
const _hoisted_29 = { class: "font-bold text-center uppercase mb-3" };
const _hoisted_30 = {
    key: 0,
    class: "text-center"
};
const _hoisted_31 = ["href"];
const _hoisted_32 = ["href"];
const _hoisted_33 = {
    key: 1,
    class: "text-center"
};
const _hoisted_34 = { key: 0 };
const _hoisted_35 = ["href"];
const _hoisted_36 = {
    key: 2,
    class: "text-center"
};
const _hoisted_37 = {
    key: 3,
    class: "text-center"
};
const _hoisted_38 = {
    key: 1,
    class: "lg:grow"
};
const _hoisted_39 = { class: "font-bold text-center uppercase mb-3" };
const _hoisted_40 = { class: "text-center" };
const _hoisted_41 = ["href"];
const _hoisted_42 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-facebook text-3xl" }, null, -1);
const _hoisted_43 = [
    _hoisted_42
];
const _hoisted_44 = ["href"];
const _hoisted_45 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-instagram text-3xl" }, null, -1);
const _hoisted_46 = [
    _hoisted_45
];
const _hoisted_47 = ["href"];
const _hoisted_48 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-x-twitter text-3xl" }, null, -1);
const _hoisted_49 = [
    _hoisted_48
];
const _hoisted_50 = ["href"];
const _hoisted_51 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-youtube text-3xl" }, null, -1);
const _hoisted_52 = [
    _hoisted_51
];
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const securityStore_1 = require("../../stores/security/securityStore");
const i18n_1 = require("../../common/i18n");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const customDesignStore_1 = require("../../stores/customDesign/customDesignStore");
const salesContactsStore_1 = require("../../stores/salesContacts/salesContactsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Foot',
    setup(__props) {
        const salesContactsStore = (0, salesContactsStore_1.useSalesContactsStore)();
        const customDesignStore = (0, customDesignStore_1.useCustomDesignStore)();
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const isExportCustomer = (0, vue_3.computed)(() => {
            var _a;
            if ((_a = securityStore.authenticatedUser) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CustomerPermissionEnum.EXPORT_PARTNER)) {
                return 1;
            }
            return 0;
        });
        const companyData = ShopConfig_1.ShopConfig.getCompanyData();
        const salesContacts = (0, vue_3.computed)(() => salesContactsStore.salesContacts);
        const firstSalesContact = (0, vue_3.computed)(() => {
            if (salesContacts.value === null) {
                return null;
            }
            if (Array.isArray(salesContacts.value)) {
                return salesContacts.value[0];
            }
            return null;
        });
        const moreContactSalesVisible = (0, vue_3.ref)(false);
        (0, vue_3.onMounted)(() => {
            if (!currentUser.value)
                return;
            // initializeStore meghívása a jogososultság(ok) ellenőrzésére.
            customDesignStore.initializeStore(currentUser.value);
        });
        (0, vue_3.watch)(() => securityStore.authenticatedUser, (authUser) => {
            if (authUser !== null) {
                salesContactsStore.getCustomerSalesContacts(router, authUser.departmentDeep, isExportCustomer.value);
            }
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    ((0, vue_2.unref)(securityStore).authenticatedUser !== null &&
                        (0, vue_2.unref)(router).currentRoute.value.name !== 'app_login')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("contact", "Contact", "layout_footer")), 1),
                            ((0, vue_2.unref)(salesContacts).length === 0 && !(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                        (0, vue_2.createElementVNode)("a", {
                                            class: "font-bold underline",
                                            href: `mailto:${(0, vue_2.unref)(securityStore).authenticatedUser.customer.contactEmail}`
                                        }, (0, vue_2.toDisplayString)((_a = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _a === void 0 ? void 0 : _a.customer.contactName), 9, _hoisted_7)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((_b = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _b === void 0 ? void 0 : _b.customer.contactPhone) + ", " + (0, vue_2.toDisplayString)((_c = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _c === void 0 ? void 0 : _c.customer.contactEmail), 1)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, (0, vue_2.toDisplayString)((_d = (0, vue_2.unref)(currentUser)) === null || _d === void 0 ? void 0 : _d.customer.name), 1))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(salesContacts).length > 0 && !(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                                    ((0, vue_2.unref)(firstSalesContact) !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                                ((0, vue_2.unref)(firstSalesContact).email !== '')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                        key: 0,
                                                        class: "font-bold underline",
                                                        href: `mailto:${(0, vue_2.unref)(firstSalesContact).email}`
                                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(firstSalesContact).name), 9, _hoisted_13))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                ((0, vue_2.unref)(firstSalesContact).email === '')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(firstSalesContact).name), 1))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                ((0, vue_2.unref)(firstSalesContact).jobCategory !== '')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_15, " | " + (0, vue_2.toDisplayString)((0, vue_2.unref)(firstSalesContact).jobCategory), 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                                ((0, vue_2.unref)(firstSalesContact).formattedPhone !== '')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(firstSalesContact).formattedPhone), 1))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                ((0, vue_2.unref)(firstSalesContact).formattedPhone !== '' &&
                                                    (0, vue_2.unref)(firstSalesContact).email !== '')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_18, ", "))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                ((0, vue_2.unref)(firstSalesContact).email !== '')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(firstSalesContact).email), 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (!moreContactSalesVisible.value && (0, vue_2.unref)(salesContacts).length > 1)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: 1,
                                            onClick: _cache[0] || (_cache[0] = ($event) => (moreContactSalesVisible.value = true)),
                                            class: "border text-center px-3 cursor-pointer inline-block mx-auto"
                                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("additional_contacts", "Additional contacts", "layout_footer")), 1))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (moreContactSalesVisible.value && (0, vue_2.unref)(salesContacts).length > 1)
                                        ? ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 2 }, (0, vue_2.renderList)((0, vue_2.unref)(salesContacts).slice(1), (salesContact) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: salesContact['@id']
                                            }, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                                    (salesContact.email !== '')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                            key: 0,
                                                            class: "font-bold underline",
                                                            href: `mailto:${salesContact.email}`
                                                        }, (0, vue_2.toDisplayString)(salesContact.name), 9, _hoisted_21))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (salesContact.email === '')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_22, (0, vue_2.toDisplayString)(salesContact.name), 1))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (salesContact.jobCategory !== '')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_23, " | " + (0, vue_2.toDisplayString)(salesContact.jobCategory), 1))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                                    (salesContact.formattedPhone !== '')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_25, (0, vue_2.toDisplayString)(salesContact.formattedPhone), 1))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (salesContact.formattedPhone !== '' &&
                                                        salesContact.email !== '')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_26, ", "))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (salesContact.email !== '')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_27, (0, vue_2.toDisplayString)(salesContact.email), 1))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ])
                                            ]));
                                        }), 128))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_28, [
                        (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("headquarters", "Headquarters", "layout_footer")), 1),
                        (!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_30, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(companyData).phone) + " | ", 1),
                                ((0, vue_2.unref)(isExportCustomer))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                        key: 0,
                                        class: "font-bold underline",
                                        href: `mailto:${(0, vue_2.unref)(companyData).hqExportEmail}`
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(companyData).hqExportEmail), 9, _hoisted_31))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                        key: 1,
                                        class: "font-bold underline",
                                        href: `mailto:${(0, vue_2.unref)(companyData).hqEmail}`
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(companyData).hqEmail), 9, _hoisted_32))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_33, [
                                ((_e = (0, vue_2.unref)(currentUser)) === null || _e === void 0 ? void 0 : _e.customer.phone)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_34, (0, vue_2.toDisplayString)((_f = (0, vue_2.unref)(currentUser)) === null || _f === void 0 ? void 0 : _f.customer.phone) + " | ", 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("a", {
                                    class: "font-bold underline",
                                    href: `mailto:${(_g = (0, vue_2.unref)(currentUser)) === null || _g === void 0 ? void 0 : _g.customer.email}`
                                }, (0, vue_2.toDisplayString)((_h = (0, vue_2.unref)(currentUser)) === null || _h === void 0 ? void 0 : _h.customer.email), 9, _hoisted_35)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_36, (0, vue_2.toDisplayString)((0, vue_2.unref)(companyData).zip) + " " + (0, vue_2.toDisplayString)((0, vue_2.unref)(companyData).city) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(companyData).street), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_37, (0, vue_2.toDisplayString)((_j = (0, vue_2.unref)(currentUser)) === null || _j === void 0 ? void 0 : _j.customer.zipCode) + " " + (0, vue_2.toDisplayString)((_k = (0, vue_2.unref)(currentUser)) === null || _k === void 0 ? void 0 : _k.customer.city) + ", " + (0, vue_2.toDisplayString)((_l = (0, vue_2.unref)(currentUser)) === null || _l === void 0 ? void 0 : _l.customer.street), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    ((0, vue_2.unref)(companyData).socialLinks)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_38, [
                            (0, vue_2.createElementVNode)("div", _hoisted_39, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("social_media", "Social Media", "layout_footer")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_40, [
                                ((0, vue_2.unref)(companyData).socialLinks.facebook)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                        key: 0,
                                        href: (0, vue_2.unref)(companyData).socialLinks.facebook,
                                        target: "_blank",
                                        class: "mr-4"
                                    }, _hoisted_43, 8, _hoisted_41))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(companyData).socialLinks.instagram)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                        key: 1,
                                        href: (0, vue_2.unref)(companyData).socialLinks.instagram,
                                        target: "_blank",
                                        class: "mr-4"
                                    }, _hoisted_46, 8, _hoisted_44))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(companyData).socialLinks.x)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                        key: 2,
                                        href: (0, vue_2.unref)(companyData).socialLinks.x,
                                        target: "_blank",
                                        class: "mr-4"
                                    }, _hoisted_49, 8, _hoisted_47))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(companyData).socialLinks.youtube)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                        key: 3,
                                        href: (0, vue_2.unref)(companyData).socialLinks.youtube,
                                        target: "_blank"
                                    }, _hoisted_52, 8, _hoisted_50))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ])
            ]));
        };
    }
});
